/**
 * Clickable multiple-choice row backed by a **`radio`** (participant-style option).
 *
 * @param options - **`id`**, shared **`name`** (radios) or unique per checkbox, **`value`**, visible **`label`**, optional **`checked`**, optional **`variant`** (**`radio`** default).
 * @returns **`label.qz-mc`** wrapping control and text.
 */
export function createMcOptionTile(
  options: Readonly<{
    id: string;
    name: string;
    value: string;
    label: string;
    checked?: boolean;
    variant?: "radio" | "checkbox";
  }>,
): HTMLLabelElement {
  const lab = document.createElement("label");
  lab.className = "qz-mc";
  lab.htmlFor = options.id;

  const input = document.createElement("input");
  input.type = options.variant === "checkbox" ? "checkbox" : "radio";
  input.className = "qz-mc__input";
  input.id = options.id;
  input.name = options.name;
  input.value = options.value;
  if (options.checked === true) {
    input.checked = true;
  }

  const span = document.createElement("span");
  span.className = "qz-mc__label";
  span.textContent = options.label;

  lab.appendChild(input);
  lab.appendChild(span);
  return lab;
}
